import React from 'react';

interface SeverityBadgeProps {
  priority: string;
  className?: string;
}

const classMap: Record<string, string> = {
  CRITICAL: 'badge-critical',
  HIGH: 'badge-high',
  MEDIUM: 'badge-medium',
  LOW: 'badge-low',
};

const SeverityBadge: React.FC<SeverityBadgeProps> = ({ priority, className = '' }) => {
  const upper = (priority || '').toUpperCase();
  const cls = classMap[upper] || 'badge-neutral';
  return <span className={`${cls} ${className}`.trim()}>{upper || 'UNKNOWN'}</span>;
};

export default SeverityBadge;
